import { StyledSlider } from '@/pages/AdvancedEditor/components/panels/common/StyledSlider';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlNumberInput } from '../../common/ControlNumberInput';

const Container = styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    width: 220px;
`;

export const getBorderWidthField = (element: ElementType) => (checkPolotnoType(element, polotnoTypes.Line) ? 'height' : 'strokeWidth');

export const BorderWidthControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedShapes;
    const element = elements[0] as ElementType & { strokeWidth: number; height: number };

    if (!element) return null;

    const borderWidthField = getBorderWidthField(element);
    const borderWidth = element[borderWidthField];

    const handleChange = (value: number) => {
        elements.forEach(element => element.set({ [getBorderWidthField(element)]: value }));
    };

    return (
        <Container>
            <StyledSlider value={borderWidth} onChange={(_e, value) => handleChange(value as number)} step={1} min={0} max={100} />
            <ControlNumberInput value={borderWidth} onChange={handleChange} min={0} max={100} suffix="px" />
        </Container>
    );
});
